import { CALL_PACKAGES_LIST_REQUEST, CALL_PACKAGES_LIST_SUCCESS, CALL_PACKAGES_LIST_FAILURE } from '../actions/callPackageActions';

const initialState = {
  loading: false,
  list: [],
  pagination: {},
  error: null,
};

export default function callPackages(state = initialState, action) {
  switch (action.type) {
    case CALL_PACKAGES_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case CALL_PACKAGES_LIST_SUCCESS: {
      const payload = action.payload;
      const items = payload?.data?.items || payload?.data || payload?.items || [];
      const pagination = {
        totalCount: payload?.data?.totalCount || payload?.totalCount || items.length || 0,
      };
      return { ...state, loading: false, list: items, pagination };
    }
    case CALL_PACKAGES_LIST_FAILURE:
      return { ...state, loading: false, error: action.error || 'Failed to fetch call packages' };
    default:
      return state;
  }
}
